import React, { useState, useContext } from 'react';
import MethodsOneContext from './../Contexts/MethodsOne';


function Search(props) {


  const [text, setText] = useState('');

  const methodsOneContext = useContext(MethodsOneContext);


  let searchHandler = value => {
    methodsOneContext.searchHandler(text);
  }

  let inputHandler = e => setText(e.target.value)

  return (
    <>
      <div class="search-box_discuss search-box_discuss_width" ><form action="" autoComplete="off">
        <div class="search-box">
          <input type="text" value={text} onChange={inputHandler} name="search" placeholder="عنوان مطلبی که به دنبال آن میگردید را اینجا وارد کنید ..." />
          <button onClick={() => searchHandler()} type="button">جستجو کن</button></div></form>  </div>
    </>
  )
}

export default Search;